import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'filterBy'
})
export class FilterByPipe implements PipeTransform {

  transform(value: any[], field?: string, fieldValue?: any): any {
    if (!value || !Array.isArray(value)) {
      return null;
    }

    return value.filter(v => this.getValue(field, v) === fieldValue);
  }

  private getValue(field: string, obj: any): any {
    const nestedFields = field.split('.');
    let val = obj;
    nestedFields.forEach(f => val = val[f]);
    return val;
  }
}
